package uk.co.nickthecoder.glok.scene

import uk.co.nickthecoder.glok.backend.backend

/**
 * A plain, rectangular border using a single color.
 */
object PlainBorder : Border {

    override fun draw(x: Float, y: Float, width: Float, height: Float, color: Color, size: Edges) {
        if (color.alpha != 0f) {
            if (size.allPositive()) {
                backend.strokeInsideRect(
                    x, y, x + width, y + height,
                    x + size.left, y + size.top, x + width - size.right, y + height - size.bottom,
                    color
                )
            } else {
                var top = y
                if (size.top > 0f) {
                    backend.fillRect(x, y, x + width, y + size.top, color)
                    top += size.top
                }
                var bottom = y + height
                if (size.bottom > 0f) {
                    backend.fillRect(x, bottom, x + width, bottom - size.bottom, color)
                    bottom -= size.bottom
                }
                if (size.left > 0f) {
                    backend.fillRect(x, top, x + size.left, bottom, color)
                }
                if (size.right > 0f) {
                    backend.fillRect(x + width, top, x + width - size.right, bottom, color)
                }
            }
        }
    }

    override fun toString() = "PlainBorder"

}
